import { render } from "./TestAllObjects.vue?vue&type=template&id=2e43e17e"
import script from "./TestAllObjects.vue?vue&type=script&lang=js"
export * from "./TestAllObjects.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__